module.exports = __webpack_public_path__ + "img/G5.e6ddf1a8.png";